import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const IMAGES = [
  {
    src: "/assets/motolog/inicio.jpg",
    alt: "MotoLog dashboard",
  },
  {
    src: "/assets/motolog/estadisticas.jpg",
    alt: "MotoLog maintenance screen",
  },
  {
    src: "/assets/motolog/historial.jpg",
    alt: "MotoLog service history",
  },
  {
    src: "/assets/motolog/motos.jpg",
    alt: "MotoLog vehicle screen",
  },
  {
    src: "/assets/motolog/servicios.jpg",
    alt: "MotoLog services screen",
  },
];

export default function ProjectGallery() {
  const [activeIndex, setActiveIndex] = useState(0);

  const activeImage = IMAGES[activeIndex];

  return (
    <div className="w-full">
      <div className="relative overflow-hidden rounded-2xl border border-white/[0.08] bg-[#010710]">
        <div className="flex items-center justify-center bg-white/[0.015] p-3 sm:p-4">
          <AnimatePresence mode="wait">
            <motion.img
              key={activeImage.src}
              src={activeImage.src}
              alt={activeImage.alt}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
              className="h-auto max-h-[620px] w-full rounded-xl object-contain"
            />
          </AnimatePresence>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-4 gap-3">
        {IMAGES.map((image, index) => {
          const active = index === activeIndex;

          return (
            <button
              key={image.src}
              type="button"
              onClick={() => setActiveIndex(index)}
              aria-label={`View ${image.alt}`}
              aria-current={active}
              className={`group relative overflow-hidden rounded-xl border transition ${
                active
                  ? "border-white/30"
                  : "border-white/[0.07] hover:border-white/20"
              }`}
            >
              <div className="aspect-[16/10] bg-[#010710] p-1.5">
                <img
                  src={image.src}
                  alt=""
                  className={`h-full w-full rounded-lg object-cover transition duration-300 ${
                    active ? "opacity-100" : "opacity-40 group-hover:opacity-70"
                  }`}
                />
              </div>

              {active && (
                <motion.div
                  layoutId="gallery-indicator"
                  className="absolute inset-0 rounded-xl ring-1 ring-inset ring-white/20"
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
